module.exports = __webpack_public_path__ + "static/media/WheatStage108.e5f6c2fc.PNG";